module.exports = __webpack_public_path__ + "static/media/rocket-launch.24efb9e8.svg";